import React, { useMemo } from "react";
import { Icon, PlainButton } from "@culturehq/components";
import { Trans } from "app/utils";
import deepClone from "app/utils/deepClone";
import StoryQuestionModal from "./StoryQuestionModal";
import NewStoryQuestionModal from "./NewStoryQuestionModal";

const DuplicateTrend = ({ storyQuestion, onCreate }) => (
  <NewStoryQuestionModal
    storyQuestion={storyQuestion}
    onCreate={onCreate}
    selectedOptions={storyQuestion.storyQuestionTags}
    duplicate
  >
    {onTrigger => (
      <PlainButton
        onClick={event => {
          event.stopPropagation();
          onTrigger();
        }}
      >
        <Icon icon="copy" />
        <Trans>Duplicate</Trans>
      </PlainButton>
    )}
  </NewStoryQuestionModal>
);

const DuplicatePrompt = ({ storyQuestion, onCreate }) => (
  <StoryQuestionModal
    storyQuestion={storyQuestion}
    onCreate={onCreate}
    selectedOptions={storyQuestion.storyQuestionTags}
    duplicate
  >
    {onTrigger => (
      <PlainButton onClick={onTrigger}>
        <Icon icon="copy" />
        <Trans>Duplicate</Trans>
      </PlainButton>
    )}
  </StoryQuestionModal>
);

const DuplicateStoryQuestionOption = ({ type, storyQuestion, onCreate }) => {
  const duplicatedStoryQuestion = useMemo(() => {
    const dupStoryQuestion = deepClone(storyQuestion);
    dupStoryQuestion.question = `${dupStoryQuestion.question} (Duplicated)`;

    return dupStoryQuestion;
  }, [storyQuestion]);

  const DuplicateComponent = {
    prompt: DuplicatePrompt,
    trend: DuplicateTrend
  }[type];

  if (!DuplicateComponent) return null;

  return (
    <DuplicateComponent
      storyQuestion={duplicatedStoryQuestion}
      onCreate={onCreate}
    />
  );
};

export default DuplicateStoryQuestionOption;
